import { Upload } from '@appkit4/react-components/upload';

interface UploadSampleProps {
  onFileChange: (file: File | null) => void;
  acceptFileType?: string;
  uploadInstruction?: string;
  maxFileSize?: number | null;
}

const UploadSample = ({ onFileChange, acceptFileType, uploadInstruction, maxFileSize = 150 * 1024 * 1024 }: UploadSampleProps) => {
  const onChange = (fileData: any) => {
    if (fileData && fileData.originFile instanceof File) {
      onFileChange(fileData.originFile);
    } else {
      onFileChange(null);
    }
  };

  return (
    <Upload
      className="custom-upload"
      onChange={onChange}
      multiple={false}
      autoUpload={false}
      acceptFileType={acceptFileType}
      uploadInstruction={uploadInstruction}
      {...(maxFileSize === null ? {} : { maxFileSize })}
      action="/"
      config={{
        trigger: false,
        type: 'inline',
        size: true,
      }}
    />
  );
};

export default UploadSample;
